import { useTranslation } from 'react-i18next';

import { useGetTeam } from '@entities/myTeam/lib/hooks';
import { getPluralized } from '@shared/helpers';
import { useChangeCurrentModal } from '@widgets/MyTeam/lib/hooks/useChangeCurrentModal';

export const useMyTeam = () => {
    const { t } = useTranslation();
    const {
        currentModal,
        currentClickedId,
        onCloseCurrentModal,
        onChangeCurrentModal,
        onChangeCurrentClickedId,
    } = useChangeCurrentModal();

    const { isGetTeamLoading, data } = useGetTeam();

    const countEmployers = getPluralized(data?.totalCount, {
        one: t('MyTeam.return.section.header.mediumPlain.one'),
        few: t('MyTeam.return.section.header.mediumPlain.few'),
        many: t('MyTeam.return.section.header.mediumPlain.many'),
    });
    return {
        t,
        countEmployers,
        currentModal,
        onCloseCurrentModal,
        onChangeCurrentModal,
        totalCount: data?.totalCount,
        isCanAddEmployee: data?.isCanAddEmployee,
        isOwner: data?.isOwner,
        isGetTeamLoading,
        currentClickedId,
        onChangeCurrentClickedId,
    };
};
